import TextArea from "../../../form/TextArea";
import React from "react";


export default (propsTop) => {
    const {props, state, parent} = propsTop;
    const {hidden, labels, pool, operationitems, actionButtons} = props;
    return (
        (hidden || []).indexOf("comment") === -1 && <div className="row form-row">
            <div className="col-sm-12">
                <TextArea {...props.getProps("comment")} name="comment.text"
                          value={(props.getValue("comment") || {}).text} label="Megjegyzés"
                          saveChanges={props.setFieldValue}
                />
            </div>
        </div>
    );
}